<div class="modal-container main-font">
  <form [formGroup]="formTimesheetNote" class="w-100">
    <div class="body">
      <p class="mb-0 title-modal">
        {{ modalData?.isUserLogged ? 'Inserisci nota' : 'Nota' }}
      </p>
      <p *ngIf="modalData.isUserLogged" class="mb-0 description">
        Annota ciò che consideri utile
      </p>
      <app-alert
        *ngIf="modalData?.isUserLogged"
        message="La nota è visibile all'Admin e ai tuoi PM/TL"></app-alert>
      <div
        *ngIf="modalData?.isUserLogged; else readOnly"
        class="note-container">
        <p class="mb-0 text-note">Nota</p>
        <textarea
          class="my-scrollbar"
          nz-input
          formControlName="note"
          [readOnly]="!modalData?.isUserLogged"
          [nzAutosize]="{ minRows: 3, maxRows: 5 }"
          placeholder="Scrivi qui..."></textarea>
      </div>
      <ng-template #readOnly>
        <div class="d-flex align-items-center justify-content-start gap-2">
          <img
            [src]="_utilityService.getSanitizeUrl(modalData?.user.path)"
            [alt]="modalData?.user.firstName"
            class="user-img" />
          <p class="mb-0 text-user">
            {{ modalData?.user.firstName }} {{ modalData?.user.lastName }}
          </p>
        </div>
        <p class="mb-0 text-note">{{ formTimesheetNote.value.note }}</p>
      </ng-template>
    </div>
    <div class="btn-container">
      <button
        class="w-100"
        [class]="{
          'primry-btn-outline-new': modalData?.isUserLogged,
          'primary-btn-new': !modalData?.isUserLogged
        }"
        (click)="closeModal()">
        {{ modalData.isUserLogged ? 'Annulla' : 'Chiudi' }}
      </button>
      <button
        *ngIf="modalData?.isUserLogged"
        class="primary-btn-new w-100"
        (click)="saveNote()"
        [disabled]="formTimesheetNote.invalid">
        Salva
      </button>
    </div>
  </form>
</div>
